import PageLayout from '@/components/feature/PageLayout';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteInfo.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <PageLayout>
      <SEO
        title="黑料 | 51黑料网 91黑料网 17黑料网 - 51黑料最新与718黑料合集入口"
        description="✨聚合51黑料网、91黑料网、17黑料网等热门数字黑料子品牌入口，提供51黑料最新地址、17黑料吃瓜视频、🍿718黑料合集，一站浏览数字系列黑料内容。"
        keywords="黑料,51黑料网,51黑料,91黑料网,17黑料网,黑料718,91黑料吃瓜,黑料51,51黑料最新,17黑料地址,718黑料合集,91黑料入口"
        canonicalUrl="https://51heiliao.com"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <CategoryNav />
      <FeaturedArticles />
      <LatestArticles />

      <section className="max-w-7xl mx-auto px-4 md:px-6 py-10">
        <div className="bg-background-100 rounded-xl p-8 md:p-10 text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
            热门标签
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            探索最受关注的黑料话题
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { label: '51黑料最新', href: '/category/51heiliao' },
              { label: '91黑料吃瓜', href: '/category/91heiliao' },
              { label: '17黑料视频', href: '/category/17heiliao' },
              { label: '718黑料合集', href: '/category/718heiliao' },
              { label: '吃瓜爆料', href: '/category/chiigua' },
              { label: '热点追踪', href: '/category/redian' },
              { label: '黑料入口', href: '/category/51heiliao' },
              { label: '最新地址', href: '/category/51heiliao' },
            ].map((tag) => (
              <a
                key={tag.label}
                href={tag.href}
                className="px-5 py-2.5 bg-background-50 rounded-full text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-all duration-200 border border-background-200/70 hover:border-primary-200 whitespace-nowrap"
              >
                #{tag.label}
              </a>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}